import { render, staticRenderFns } from "./LineItemDialog.vue?vue&type=template&id=175c4546&scoped=true"
import script from "./LineItemDialog.vue?vue&type=script&lang=js"
export * from "./LineItemDialog.vue?vue&type=script&lang=js"
import style0 from "./LineItemDialog.vue?vue&type=style&index=0&id=175c4546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175c4546",
  null
  
)

export default component.exports